'use strict';

exports.__esModule = true;
var RESPONSIVE_DRAWER_TOGGLE_DRAWER_OPEN = exports.RESPONSIVE_DRAWER_TOGGLE_DRAWER_OPEN = 'RESPONSIVE_DRAWER_TOGGLE_DRAWER_OPEN';
var RESPONSIVE_DRAWER_TOGGLE_DRAWER_DOCK = exports.RESPONSIVE_DRAWER_TOGGLE_DRAWER_DOCK = 'RESPONSIVE_DRAWER_TOGGLE_DRAWER_DOCK';
var RESPONSIVE_DRAWER_SET_DRAWER_OPEN = exports.RESPONSIVE_DRAWER_SET_DRAWER_OPEN = 'RESPONSIVE_DRAWER_SET_DRAWER_OPEN';
var RESPONSIVE_DRAWER_SET_RESPONSIVE = exports.RESPONSIVE_DRAWER_SET_RESPONSIVE = 'RESPONSIVE_DRAWER_SET_RESPONSIVE';


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-responsive-drawer/lib/store/types.js
// module id = 620
// module chunks = 49